import { css } from 'styled-components';
import token from 'styled-token';
import { BUTTON_SHAPES } from '../../constants';
import { iconSizeMixin } from '../iconSizeMixin';
import { spaceMixin } from '../spaceMixin';
import { ButtonMixin } from './ButtonMixin';
var SquareIconButton = function SquareIconButton(props) {
  var size = props.size;
  return token({
    buttonSize: "IconButton.size." + size
  }, function (_ref) {
    var buttonSize = _ref.buttonSize;
    return css(["", " height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", ";&[aria-pressed='true']:disabled{opacity:1;}"], ButtonMixin, buttonSize, buttonSize, spaceMixin(size === 'xs' ? 'xs' : 'sm')(props));
  });
};
var CircleIconButton = function CircleIconButton() {
  return token({
    borderRadius: 'IconButton.circle.borderRadius'
  }, function (_ref2) {
    var borderRadius = _ref2.borderRadius;
    return css(["", " border-radius:", ";"], SquareIconButton, borderRadius);
  });
};

/** @class IconButtonMixin */
/** @method */
export var IconButtonMixin = function IconButtonMixin(props) {
  var appearance = props.appearance,
    size = props.size;
  return css(["", ";span{", "}"], appearance === BUTTON_SHAPES.circle ? CircleIconButton : SquareIconButton, iconSizeMixin(Object.assign({}, props, {
    iconSize: size === 'xs' || size === 'sm' ? 'xs' : 'sm'
  })));
};